import Axios from 'axios';

function get(lang) {
  return Axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v1/translation?lang=${lang}`).then(
    ({ data }) => data
  );
}

export default {
  get
};
